export default "__VITE_ASSET__DGNtnHOp__"